<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <NormalButton
          :text="buttonName"
          height="32px"
          width="110px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <MasterTransferAccountDialog
          v-model="dialogInfo.register"
          @success="registerSuccess()"
        />
      </template>
      <template #list>
        <div class="transferAccountTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getTransferAccountListFromState()"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.name`]="{ item }">
              <div class="font-weight-bold">{{ item.name || '-' }}</div>
            </template>
            <template #[`item.defaultCurrencyId`]="{ item }">
              <div class="text-center">
                {{ getCurrencyName(item.defaultCurrencyId) || '----' }}
              </div>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.editAndDelete`]="{ item }">
              <v-row>
                <v-col cols="6" class="text-center px-0">
                  <WhiteButton
                    text="common.common_edit"
                    height="32px"
                    width="48px"
                    @click.native="edit(item)"
                  />
                </v-col>
                <v-col cols="6" class="text-center px-0">
                  <WhiteButton
                    text="common.input_delete"
                    height="32px"
                    width="48px"
                    @click.native="deleteInfo(item)"
                  />
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <MasterTransferAccountDialog
      v-model="dialogInfo.edit"
      :transferAccountData="transferAccountData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import headers from './headers'
import { Master } from '@/components/layouts'
import { MasterTransferAccountDialog } from '@/components/layouts/Dialogs'
import { NormalButton, WhiteButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    Master,
    MasterTransferAccountDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      pageTitle: 'common.common_transfer-account-management',
      buttonName: 'common.common_transfer-account-register',
      transferAccountData: {},
      dialogInfo: {
        register: false,
        edit: false
      },
      headers: headers.headers,
      itemKey: 'transferAccountId',
      editMode: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    }
  },
  methods: {
    ...mapActions('TransferAccount', [
      'getTransferAccountListFromApi',
      'deleteTransferAccount'
    ]),
    ...mapGetters('TransferAccount', ['getTransferAccountListFromState']),
    ...mapGetters('Common', ['getCurrencyListFromState']),
    async init() {
      await this.getTransferAccountListFromApi()
    },
    getCurrencyName(currencyId) {
      const defaultCurrency = this.getCurrencyListFromState().find(
        (element) => element.currencyId === currencyId
      )
      if (defaultCurrency) {
        return defaultCurrency.name
      } else {
        return ''
      }
    },
    edit(transferAccount) {
      this.transferAccountData = _cloneDeep(transferAccount)
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async deleteInfo(transferAccount) {
      const isConfirmed = confirm(
        this.$t('master.transfer-account_confirm-to-delete-transfer-account')
      )
      if (!isConfirmed) {
        return
      }
      transferAccount.id = transferAccount.TransferAccountId
      const success = await this.deleteTransferAccount(transferAccount)
      this.init()
      alert(this.$t('common.common_delete-comp'))
    }
  }
}
</script>
<style scoped lang="scss">
.transferAccountTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
</style>
